module.exports = __webpack_public_path__ + "d308073b/img/settings-icon.121d9519.svg";